function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, Object, String, description, hidden, invalidInputWarning, locked, name, saving) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['name-input'] = function({
      isOptional = false,
      description = {},
      label = `Name`,
      inputHandler = $helpers.handleNameInput,
      inputValue = name,
      placeHolderValue = defaultPlaceHolderValue,
      elRef = `nameInput`
    } = {}) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(($attr(`warning`)) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'warning': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'icon': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("svg-icon", {
                "attrs": {
                  icon: `warning`
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'text': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("" + ($attr(`warning`)) + "");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("mp-input", {
          "attrs": {
            placeholder: placeHolderValue,
            label: label,
            necessary: isOptional ? `optional` : ``,
          },
          "props": {
            value: inputValue,
          },
          "on": {
            input: inputHandler,
            keydown: $helpers.handleKeydown,
            blur: $helpers.warnInvalidInput,
          },
          "hook": {
            insert: ({
              elm
            }) => $component.setElRef(elRef, elm),
            destroy: () => $component.setElRef(elRef, null),
          },
          "class": {
            'entity-name-input': true
          },
        }));
        __jade_nodes = __jade_nodes.concat((description) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'input-description': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'input-description-text': true
              },
            }, [__vjadeSafeCode(typeof description.text === "undefined" ? "" : description.text)]));
            __jade_nodes = __jade_nodes.concat((description.learnMoreLink) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("a", {
                "attrs": {
                  href: `https://help.mixpanel.com/hc/en-us/articles/360025333632#implementation`,
                  target: `_blank`
                },
                "class": {
                  'input-description-learn-more': true
                },
              }, [__vjadeSafeCode(`Learn More`)]));;
              return __jade_nodes
            }).call(this)) : undefined);;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": Object.assign({}, {
            'show-error': invalidInputWarning === `name`
          }, {
            'entity-input-error-container': true
          }),
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'entity-input-error': true
            },
          }, [__vjadeSafeCode($helpers.getNameError())]));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this);
    };

    jade_mixins['create-data-group-input-group'] = function() {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(jade_mixins['name-input'].call(this, {
          label: `Event property`,
          description: {
            text: `Type an event property to use as a Unique Group Identifier`,
            learnMoreLink: `https://help.mixpanel.com/hc/en-us/articles/360025333632#implementation`,
          },
          placeHolderValue: `eg. company_id`,
        }));
        __jade_nodes = __jade_nodes.concat(jade_mixins['name-input'].call(this, {
          label: `Display name`,
          isOptional: true,
          description: {
            text: `The group key name that displays in the Mixpanel interface`,
          },
          inputHandler: $helpers.handleDescriptionInput,
          inputValue: description,
          placeHolderValue: `eg. Company`,
          elRef: `descriptionTextarea`,
        }));;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    const defaultPlaceHolderValue = `Untitled ${$helpers.capitalize($attr(`entity-type`))}`;
    return {
      value: (h("mp-modal", {
        "attrs": {
          open: $attr(`open`),
          'modal-title': $attr(`modal-title`),
          'modal-description': `Modal for managing ${$helpers.getEntityTypePluralStr()}`,
        },
        "on": {
          change: $helpers.handleModalChange
        },
        "class": {
          'modal': true,
          'create-entity-modal': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-card-header': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-card-header-title': true
            },
          }, [__vjadeSafeCode($attr(`modal-title`))]));;
          return __jade_nodes
        }).call(this).filter(Boolean)));
        __jade_nodes = __jade_nodes.concat(h("div", {
          "class": {
            'mp-modal-content': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(($attr(`entity-type`) == `data group`) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['create-data-group-input-group'].call(this));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['name-input'].call(this));
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'entity-description-label': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Description");
              __jade_nodes = __jade_nodes.concat(h("div", {
                "class": {
                  'entity-description-label-optional': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Optional");;
                return __jade_nodes
              }).call(this).filter(Boolean)));;
              return __jade_nodes
            }).call(this).filter(Boolean)));
            __jade_nodes = __jade_nodes.concat(h("textarea", {
              "on": {
                input: $helpers.handleDescriptionInput,
                keydown: $helpers.handleKeydown,
              },
              "props": {
                placeholder: 'Enter a short description for your ' + ($attr(`entity-type`)) + '',
                value: description,
              },
              "hook": {
                insert: ({
                  elm
                }) => $component.setElRef('descriptionTextarea', elm),
                destroy: () => $component.setElRef('descriptionTextarea', null),
              },
              "class": {
                'entity-description-textarea': true
              },
            }));;
            return __jade_nodes
          }).call(this)));
          __jade_nodes = __jade_nodes.concat(($helpers.areVisibilityControlsEnabled()) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'entity-visibility-controls-container': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-visibility-controls", {
                "attrs": {
                  'entity-type': $attr(`entity-type`),
                  'entity-type-plural': $helpers.getEntityTypePluralStr(),
                  'hidden-value': hidden,
                  'hidden-disabled': $attr(`hidden-disabled`),
                  'locked-value': locked,
                  'locked-disabled': $attr(`lock-disabled`),
                },
                "on": {
                  changeHidden: $helpers.handleVisibilityHiddenChange,
                  changeLocked: $helpers.handleVisibilityLockedChange,
                },
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : undefined);
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'modal-footer': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'modal-actions': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  theme: `tertiary`
                },
                "on": {
                  click: $helpers.cancelChanges
                },
                "class": {
                  'modal-actions-cancel': true
                },
              }, (function() {
                var __jade_nodes = [];
                __jade_nodes = __jade_nodes.concat("Cancel");;
                return __jade_nodes
              }).call(this).filter(Boolean)));
              __jade_nodes = __jade_nodes.concat(h("mp-button", {
                "attrs": {
                  theme: `primary`,
                  disabled: !$helpers.hasValidName() || Boolean(saving),
                  icon: saving ? `spinner` : ``,
                  testref: `saveEntity`,
                },
                "on": {
                  click: $helpers.saveChanges
                },
                "class": {
                  'modal-actions-confirm': true
                },
              }, [__vjadeSafeCode(saving ? `Saving` : `Save`)]));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "description" in locals ? locals.description : typeof description !== "undefined" ? description : undefined, "hidden" in locals ? locals.hidden : typeof hidden !== "undefined" ? hidden : undefined, "invalidInputWarning" in locals ? locals.invalidInputWarning : typeof invalidInputWarning !== "undefined" ? invalidInputWarning : undefined, "locked" in locals ? locals.locked : typeof locked !== "undefined" ? locked : undefined, "name" in locals ? locals.name : typeof name !== "undefined" ? name : undefined, "saving" in locals ? locals.saving : typeof saving !== "undefined" ? saving : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;